import Vue from 'vue';

export function setWindowWidth (state, payload) {
    state.windowWidth = payload;
}

export function setWindowHeight (state, payload) {
    state.windowHeight = payload;
}

export function setActiveBreakpoints (state, payload) {
    state.activeBreakpoints = payload;
}

export function setScrollMagicController (state, payload) {
    state.scrollMagicController = payload;
}

export function setHeaderHeight (state, payload) {
    state.headerHeight = payload;
}

export function setActiveFlyout (state, payload) {
    state.activeFlyout = payload;
}

export function setBrowser (state, payload) {
    state.browser = payload;
}

export function setLockPage (state, payload) {
    state.lockPage = payload;
}

export function setSearchBarVisibility (state, payload) {
    state.searchBarVisible = payload;
}

export function setSearchQuery (state, payload) {
    state.searchQuery = payload;
}

export function setSearchLoading (state, payload) {
    state.searchLoading = payload;
}

export function setSearchSuggestionsLoading (state, payload) {
    state.searchSuggestionsLoading = payload;
}

export function setSearchResults (state, payload) {
    Vue.set(state.searchResults, payload.key, payload.results);
}

export function setSearchSuggestions (state, payload) {
    if (payload.key) {
        Vue.set(state.searchSuggestions, payload.key, payload.results);
    } else {
        state.searchSuggestions = payload;
    }
}

export function setSearchClient (state, payload) {
    state.searchClient = payload;
}

export function setSearchResultsActive (state, payload) {
    state.searchResultsActive = payload;
}

export function setSearchSuggestionsActive (state, payload) {
    state.searchSuggestionsActive = payload;
}

export function setActiveSearchCategoryTab (state, payload) {
    state.activeSearchCategoryTab = payload;
}

export function setSearchSuggestionsCurrentlyVisible (state, payload) {
    state.searchSuggestionsCurrentlyVisible = payload;
}
